import { render, staticRenderFns } from "./VcitaMeter.vue?vue&type=template&id=06541bbd&scoped=true"
import script from "./VcitaMeter.vue?vue&type=script&lang=js"
export * from "./VcitaMeter.vue?vue&type=script&lang=js"
import style0 from "./VcitaMeter.vue?vue&type=style&index=0&id=06541bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06541bbd",
  null
  
)

export default component.exports